import { Group, Paper, Title } from '@mantine/core';
import { type Dayjs } from 'dayjs';
import { type ReactElement } from 'react';
import { FaAngleLeft, FaAngleRight } from 'react-icons/fa';

interface Props {
  value: Dayjs;
  setValue: (month: Dayjs) => void;
  additionalActionOnClick?: () => void;
}

export const MonthSelector = (props: Props): ReactElement => {
  const { value, setValue, additionalActionOnClick } = props;
  return (
    <Paper withBorder radius="md" className="p-4">
      <Group className="justify-between">
        <div className="cursor-pointer transition-all duration-200 hover:text-blue-500">
          <FaAngleLeft
            onClick={() => {
              setValue(value.subtract(1, 'month'));
              additionalActionOnClick?.();
            }}
          />
        </div>
        <Title order={2}>{value.format('MMMM YYYY')}</Title>
        <div className="cursor-pointer transition-all duration-200 hover:text-blue-500">
          <FaAngleRight
            onClick={() => {
              setValue(value.add(1, 'month'));
              additionalActionOnClick?.();
            }}
          />
        </div>
      </Group>
    </Paper>
  );
};
